/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /press_release/{release_id}/duplicate
 * @export
 * @interface DuplicatePressReleaseSuccessResponse
 */
export interface DuplicatePressReleaseSuccessResponse {
    /**
     * status code
     * @type {number}
     * @memberof DuplicatePressReleaseSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePressReleaseSuccessResponse
     */
    message: string;
    /**
     * 複製されたプレスリリースID
     * @type {number}
     * @memberof DuplicatePressReleaseSuccessResponse
     */
    duplicateReleaseId: number;
}

export function DuplicatePressReleaseSuccessResponseFromJSON(json: any): DuplicatePressReleaseSuccessResponse {
    return DuplicatePressReleaseSuccessResponseFromJSONTyped(json, false);
}

export function DuplicatePressReleaseSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicatePressReleaseSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'duplicateReleaseId': json['duplicate_release_id'],
    };
}

export function DuplicatePressReleaseSuccessResponseToJSON(value?: DuplicatePressReleaseSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'duplicate_release_id': value.duplicateReleaseId,
    };
}

